export const plus = {
  plus: {
    width: 448,
    height: 448,
    d: 'M416,176L272,176L272,32C272,14.33 257.67,0 240,0L208,0C190.33,0 176,14.33 176,32L176,176L32,176C14.33,176 0,190.33 0,208L0,240C0,257.67 14.33,272 32,272L176,272L176,416C176,433.67 190.33,448 208,448L240,448C257.67,448 272,433.67 272,416L272,272L416,272C433.67,272 448,257.67 448,240L448,208C448,190.33 433.67,176 416,176Z',
  },
};

export const minus = {
  minus: {
    width: 448,
    height: 448,
    d: 'M416,176L32,176C14.33,176 0,190.33 0,208L0,240C0,257.67 14.33,272 32,272L416,272C433.67,272 448,257.67 448,240L448,208C448,190.33 433.67,176 416,176Z',
  },
};

export const expand = {
  expand: {
    width: 448,
    height: 448,
    d: 'M0,148L0,24C0,10.7 10.7,0 24,0L148,0C154.6,0 160,5.4 160,12L160,52C160,58.6 154.6,64 148,64L64,64L64,148C64,154.6 58.6,160 52,160L12,160C5.4,160 0,154.6 0,148ZM288,12L288,52C288,58.6 293.4,64 300,64L384,64L384,148C384,154.6 389.4,160 396,160L436,160C442.6,160 448,154.6 448,148L448,24C448,10.7 437.3,0 424,0L300,0C293.4,0 288,5.4 288,12ZM436,288L396,288C389.4,288 384,293.4 384,300L384,384L300,384C293.4,384 288,389.4 288,396L288,436C288,442.6 293.4,448 300,448L424,448C437.3,448 448,437.3 448,424L448,300C448,293.4 442.6,288 436,288ZM160,436L160,396C160,389.4 154.6,384 148,384L64,384L64,300C64,293.4 58.6,288 52,288L12,288C5.4,288 0,293.4 0,300L0,424C0,437.3 10.7,448 24,448L148,448C154.6,448 160,442.6 160,436Z',
  },
};

export const questionMark = {
  questionMark: {
    width: 16,
    height: 16,
    d: 'm 8.93,6.588 -2.29,0.287 -0.082,0.38 0.45,0.083 c 0.294,0.07 0.352,0.176 0.288,0.469 l -0.738,3.468 c -0.194,0.897 0.105,1.319 0.808,1.319 0.545,0 1.178,-0.252 1.465,-0.598 L 8.919,11.58 c -0.2,0.176 -0.492,0.246 -0.686,0.246 -0.275,0 -0.375,-0.193 -0.304,-0.533 z M 9,4.5 a 1,1 0 1 1 -2,0 1,1 0 0 1 2,0 z M 8,15 A 7,7 0 1 1 8,1 7,7 0 0 1 8,15 Z m 0,1 A 8,8 0 1 0 8,0 8,8 0 0 0 8,16 Z',
  },
};

export const shift = {
  shift: {
    width: 512,
    height: 512,
    d: 'M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm292 116V256h70.9c10.7 0 16.1-13 8.5-20.5L264.5 121.2c-4.7-4.7-12.2-4.7-16.9 0l-115 114.3c-7.6 7.6-2.2 20.5 8.5 20.5H212v116c0 6.6 5.4 12 12 12h64c6.6 0 12-5.4 12-12z',
  },
};

export const twitter = {
  twitter: {
    width: 512,
    height: 512,
    d: 'M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z',
  },
};

export const copy = {
  copy: {
    width: 448,
    height: 512,
    d: 'M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z',
  },
};

export const information = {
  info: {
    width: 15,
    height: 15,
    d: 'M7.49968 0C3.3581 0 0 3.3581 0 7.49968C0 11.6413 3.3581 15 7.49968 15C11.6413 15 15 11.6413 15 7.49968C15 3.3581 11.6413 0 7.49968 0ZM9.06095 11.6235C8.67492 11.7759 8.36762 11.8914 8.13714 11.9714C7.9073 12.0514 7.64 12.0914 7.33587 12.0914C6.86857 12.0914 6.50476 11.9771 6.24571 11.7492C5.98667 11.5213 5.85778 11.2324 5.85778 10.8813C5.85778 10.7448 5.8673 10.6051 5.88635 10.4629C5.90603 10.3206 5.93714 10.1606 5.97968 9.98095L6.46286 8.27429C6.5054 8.11048 6.54222 7.95492 6.57143 7.81016C6.60064 7.66413 6.6146 7.53016 6.6146 7.40825C6.6146 7.19111 6.56952 7.03873 6.48 6.95302C6.38921 6.8673 6.21841 6.8254 5.96381 6.8254C5.83937 6.8254 5.71111 6.84381 5.57968 6.88254C5.44952 6.92254 5.33651 6.95873 5.24381 6.99429L5.37143 6.46857C5.68762 6.33968 5.99048 6.22921 6.27937 6.13778C6.56825 6.04508 6.84127 5.99937 7.09841 5.99937C7.56254 5.99937 7.92064 6.11238 8.1727 6.33587C8.42349 6.56 8.54984 6.85143 8.54984 7.20952C8.54984 7.28381 8.54095 7.4146 8.52381 7.60127C8.50667 7.78857 8.47429 7.95937 8.4273 8.11619L7.94667 9.81778C7.9073 9.95429 7.87238 10.1105 7.84064 10.2851C7.80952 10.4597 7.79429 10.593 7.79429 10.6825C7.79429 10.9086 7.84444 11.0629 7.94603 11.1448C8.04635 11.2267 8.22222 11.2679 8.47111 11.2679C8.58857 11.2679 8.72 11.247 8.86857 11.2063C9.01587 11.1657 9.12254 11.1295 9.18984 11.0984L9.06095 11.6235ZM8.97587 4.71683C8.75175 4.92508 8.4819 5.02921 8.16635 5.02921C7.85143 5.02921 7.57968 4.92508 7.35365 4.71683C7.12889 4.50857 7.01524 4.25524 7.01524 3.95937C7.01524 3.66413 7.12952 3.41016 7.35365 3.2C7.57968 2.98921 7.85143 2.88444 8.16635 2.88444C8.4819 2.88444 8.75238 2.98921 8.97587 3.2C9.2 3.41016 9.31238 3.66413 9.31238 3.95937C9.31238 4.25587 9.2 4.50857 8.97587 4.71683Z',
  },
};

export const arrowDown = {
  info: {
    width: 15,
    height: 15,
    d: 'M1 1.5L6 6.5L11 1.5',
  },
};

